export const UPDATE_RESSOURCES = "UPDATE_RESSOURCES";

export const updateRessources = (value) => ({
  type: UPDATE_RESSOURCES,
  value,
});
